import { render } from "./CookiesNav.vue?vue&type=template&id=bae51b0e&scoped=true&ts=true"
import script from "./CookiesNav.vue?vue&type=script&lang=ts"
export * from "./CookiesNav.vue?vue&type=script&lang=ts"

import "./CookiesNav.vue?vue&type=style&index=0&id=bae51b0e&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae51b0e"]])

export default __exports__